import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { Permission } from 'src/app/models/principal/permission';
import { RouterSegments } from 'src/app/models/router-segments';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import cloneDeep from 'lodash/cloneDeep';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import { AddSolutionFormComponent } from '../../solution-onboarding/add-solution-form/add-solution-form.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';

const REQUIRED_PERMISSIONS = [
  Permission.ADD_SOLUTION,
  Permission.EDIT_SOLUTION,
  Permission.DELETE_SOLUTION
];

@Component({
    selector: 'app-tenant-solutions',
    templateUrl: './tenant-solutions.component.html',
    styleUrls: ['./tenant-solutions.component.scss'],
    standalone: false
})
export class TenantSolutionsComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  RouterSegments = RouterSegments;
  solutions: any[];
  tenant: string;
  dropdownsList: any = [];
  selectedLineOfBusiness: any;
  selectedCategory: any;
  selectedRegion: any;
  selectedTenant: any;
  showSpinner = false;
  solutionsPage: any[];
  defaultSolutions: any;
  searchText: string;
  paginationSize = 10;
  pageIndex = 0;
  viewSelected = 'grid';
  filteredColumns: any;
  subscription: Subscription;
  breadcrumbItems: BreadcrumbItem[] = [];
  isReader: boolean;
  Permission = Permission;
  permissionsMap: { [key: string]: boolean };
  isFailed = false;
  categoryList: any;
  regionList: any;
  tenantList: any;
  tenantId: string;

  constructor(private solutionsService: SolutionsService, public authService: AuthService, private sidenavService: SidenavService,
    private toastrService: ToastrService, public customToastrService : CustomToastrService, public dateTimeFormatService: DateTimeFormatService, private tenantService: TenantService,
    private permissionsService: PermissionsService, private dialog: MatDialog, private toastrErrorService: ToastrErrorService,
    private activatedRoute: ActivatedRoute, private router: Router) {
    
   }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.tenant = this.authService.principal.provider;
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('LEFT_SIDE_NAV.SOLUTION_ONBOARDING')},
      {label: translate('LEFT_SIDE_NAV.SOLUTIONS'), url: ['solutions']});

    const categoryOptions = [
      {value: 'SaaS' , selected: false},
      {value: 'BSG' , selected: false},
      {value: 'Demo' , selected: false},
      {value: 'Hosted' , selected: false},
    ];
    const regionOptions = [
      {value: 'APAC' , selected: false},
      {value: 'APAC_2' , selected: false},
      {value: 'AUSTRALIA' , selected: false},
      {value: 'AUSTRALIA_2' , selected: false},
      {value: 'BRAZIL' , selected: false},
      {value: 'BRAZIL_2' , selected: false},
      {value: 'CANADA' , selected: false},
      {value: 'EUROPE' , selected: false},
      {value: 'FRANCE' , selected: false},
      {value: 'GERMANY' , selected: false},
      {value: 'INDIA' , selected: false},
      {value: 'JAPAN' , selected: false},
      {value: 'KOREA' , selected: false},
      {value: 'NORWAY' , selected: false},
      {value: 'SOUTH_AFRICA' , selected: false},
      {value: 'SWEDEN' , selected: false},
      {value: 'SWITZERLAND' , selected: false},
      {value: 'UK' , selected: false},
      {value: 'NORTH_AMERICA' , selected: false},
      {value: 'NORTH_AMERICA_2' , selected: false},
      {value: 'NORTH_AMERICA_3' , selected: false},
      {value: 'NORTH_AMERICA_4' , selected: false},
      {value: 'UAE' , selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Line Of Business',
        placeholder: 'Select Line Of Business',
      },
      {
        title: 'Category',
        placeholder: 'Select Category',
        options: []
      },
      {
        title: 'Region',
        placeholder: 'Select Region',
        options: []
      },
      {
        title: 'Tenant',
        placeholder: 'Select Tenant',
        options: []
      }
    ];

    const lineOfBusiness = localStorage.getItem('tenantSerDefLineOfBusiness');
    if (lineOfBusiness) {
      this.selectedLineOfBusiness = lineOfBusiness;
    }
    const category = localStorage.getItem('tenantSerDefCategory');
    if (category) {
      this.selectedCategory = category;
    }
    const region = localStorage.getItem('tenantSerDefRegion');
    if (region) {
      this.selectedRegion = region;
    }
    this.categoryList = [...new Set(categoryOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.categoryList.forEach((value) => {
      this.dropdownsList[1].options.push({value, selected: false});
    });
    this.regionList = [...new Set(regionOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.regionList.forEach((value) => {
      this.dropdownsList[2].options.push({value, selected: false});
    });
    const tenant = localStorage.getItem('tenantSerDefTenant');
    if (tenant) {
      this.selectedTenant = tenant;
    }
    this.getTenants();

    this.loadSolutions(this.selectedLineOfBusiness,
      this.selectedCategory, this.selectedRegion, this.selectedTenant);
      localStorage.removeItem('selectedVersion');
      localStorage.removeItem('selectedVersionExtend');
  }

  getTenants(): void {
    this.dropdownsList[3].options = [];
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.tenantList = [...new Set(data.map(item => item.tenantId))];
          this.tenantList.forEach((value) => {
          this.dropdownsList[3].options.push({value, selected: false});
        });
        }
      });
  }

  loadSolutions(lineOfBusiness?, category?, regionalAvailability?, selectedTenant?): void {
    this.pageIndex = 0;
    this.showSpinner = true;
    this.isFailed = false;
    this.solutions = [];
    if (lineOfBusiness) {
      localStorage.setItem('tenantSerDefLineOfBusiness', lineOfBusiness);
    } else {
      localStorage.removeItem('tenantSerDefLineOfBusiness');
    }
    if (category) {
      localStorage.setItem('tenantSerDefCategory', category);
    } else {
      localStorage.removeItem('tenantSerDefCategory');
    }
    if (regionalAvailability) {
      localStorage.setItem('tenantSerDefRegion', regionalAvailability);
    } else {
      localStorage.removeItem('tenantSerDefRegion');
    }
    if (selectedTenant) {
      localStorage.setItem('tenantSerDefTenant', selectedTenant);
    } else {
      localStorage.removeItem('tenantSerDefTenant');
    }
    const solutionObj = {
      lineOfBusiness,
      category,
      regionalAvailability
    };
    this.solutionsService.getSolutions(solutionObj)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          data = data.sort((a,b) => b?.dateCreated?.localeCompare(a?.dateCreated));
          let filterData = data;
          if (selectedTenant) {
            filterData = data.filter(item=> item.tenantId === selectedTenant);
          }
          this.solutions = filterData;;
          let solutionLob = '';
          if (localStorage.getItem('tenantViewSolutionLob')) {
            solutionLob = JSON.parse(localStorage.getItem('tenantViewSolutionLob'));
          }
          this.defaultSolutions = filterData;
          this.searchSolution();
          if (!this.dropdownsList[0].options) {
            let options = [];

            if (!solutionLob) {
              this.solutions.forEach(solution => {
                if (!options.find(item => item.value === solution.lineOfBusiness[0])) {
                  const obj = {
                    value: solution.lineOfBusiness[0],
                    selected: false
                  };
                  options = [...options, obj];
                }
              });
              this.dropdownsList[0].options = options;
              localStorage.setItem('tenantViewSolutionLob', JSON.stringify(this.dropdownsList[0].options));
            } else {
              const defaultLob = JSON.parse(localStorage.getItem('tenantViewSolutionLob'));
              this.dropdownsList[0].options = defaultLob;
            }
          }
          this.showSpinner = false;
        }
      },
      (error) => {
        this.showSpinner = false;
        this.isFailed = true;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.customToastrService.errMessage(message, title);
        }, 500);
      });
  }

  filterColumns(): void {
    if (this.selectedLineOfBusiness) {
      this.dropdownsList[0].options.filter((item) => {
        if (item.value === this.selectedLineOfBusiness) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    if (this.selectedCategory) {
      this.dropdownsList[1].options.filter((item) => {
        if (item.value === this.selectedCategory) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[1].options.filter((item) => {
        item.selected = false;
      });
    }
    if (this.selectedRegion) {
      this.dropdownsList[2].options.filter((item) => {
        if (item.value === this.selectedRegion) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[2].options.filter((item) => {
        item.selected = false;
      });
    }
    if (this.selectedTenant) {
      this.dropdownsList[3].options.filter((item) => {
        if (item.value === this.selectedTenant) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[3].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('INSTANCE_STATUS.SOLUTION'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      lineOfBusiness: this.dropdownsList[0].options,
      category: this.dropdownsList[1].options,
      region: this.dropdownsList[2].options,
      tenant: this.dropdownsList[3].options,
      page: 'tenantSolutions'
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        if (filteredColumns) {
          this.filteredColumns = filteredColumns;
          if(filteredColumns[0] !== ''){
            this.selectedLineOfBusiness = filteredColumns[0];
          }
          if(filteredColumns[1] !== ''){
            this.selectedCategory = filteredColumns[1];
          }
          if(filteredColumns[2] !== ''){
            this.selectedRegion = filteredColumns[2];
          }
          if(filteredColumns[3] !== ''){
            this.selectedTenant = filteredColumns[3][0];
          }
          this.loadSolutions(this.selectedLineOfBusiness,
            this.selectedCategory, this.selectedRegion, this.selectedTenant);
        }
      });
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      this.solutionsPage = this.solutions.slice(firstIndex, firstIndex + this.paginationSize);
    }
  }

  resetFilter(): void {
    this.selectedLineOfBusiness = undefined;
    this.selectedCategory = undefined;
    this.selectedRegion = undefined;
    this.selectedTenant = undefined;
    this.sidenavService.searchFilter.next('data');
    this.resetAllValues();
    this.loadSolutions();
  }

  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
  }

  resetAllValues(): void {
    this.dropdownsList.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
   localStorage.removeItem('tenantViewSolutionLob');
  }

  closeMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

  filteredColumnsFunction(data): void {
    if(this.selectedLineOfBusiness === data) {
      this.selectedLineOfBusiness = undefined;
      this.resetValue(this.dropdownsList[0]);
    }else if(this.selectedCategory === data) {
      this.selectedCategory = undefined;
      this.resetValue(this.dropdownsList[1]);
    } else if(this.selectedRegion === data) {
      this.selectedRegion = undefined;
      this.resetValue(this.dropdownsList[2]);
    } else if(this.selectedTenant === data) {
      this.selectedTenant = undefined;
      this.resetValue(this.dropdownsList[3]);
    }
    this.loadSolutions(this.selectedLineOfBusiness,
      this.selectedCategory, this.selectedRegion, this.selectedTenant);
  }

  addNewSolution(): void {
    this.sidenavService.openInRightSidenav(AddSolutionFormComponent)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (!formData) {
          return;
        } else {
          this.loadSolutions();
        }
      });
  }

  editSolution(data): void {
    if (!this.permissionsMap[Permission.EDIT_SOLUTION]) {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });  
    } else {
      const editData = cloneDeep(data);
      this.sidenavService.openInRightSidenav(AddSolutionFormComponent, {editData, edit: true})
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (!formData) {
          return;
        } else {
        formData.integrations = typeof(formData.integrations) === 'string' ? formData.integrations.split(',') : formData.integrations;
        formData.keywords = typeof(formData.keywords) === 'string' ? formData.keywords.split(',') : formData.keywords;
        formData.id = data.id;
        this.loadSolutions();
        }
      });
    }
  }

  deleteSolution(data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('ADD_SOLUTION.DELETE_SOLUTION'),
        message: translate('ADD_SOLUTION.DELETE_CONFIRMATION'),
        confirmButtonText: translate('BUTTONS.DELETE')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.solutionsService.deleteSolution(data.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(response => {
            if (response) {
              this.solutions = this.solutions.filter(version => version.id !== data.id);
              this.solutionsPage = this.solutions?.slice(this.pageIndex, this.paginationSize);
              this.toastrService.success(translate('ADD_SOLUTION.SOLUTION_DELETED'));
            }
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.SOLUTION_DELETED_FAILED'),
                description: errorMessage
              }
            });
          });
        }
      });
  }

  searchSolution(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }

    this.solutions = this.defaultSolutions;
    if (this.searchText) {
      this.solutions = this.solutions?.filter(item => item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.solutions = this.defaultSolutions;
    }
    this.solutionsPage = this.solutions?.slice(this.pageIndex, this.paginationSize);
  }
  
  createService(solution) {
    localStorage.removeItem('selectedCapabilities');
    localStorage.removeItem('selectedCapabilitiesExtend');
    localStorage.removeItem('blueprintExtend');
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.BLUEPRINTS, RouterSegments.SOLUTION, solution.id]);
  }
}
 